module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.config.show) ? _c('div', {
    staticClass: "vm-vap-error"
  }, [_c('div', {
    staticClass: "vm-vap-error-img"
  }), _vm._v(" "), _c('p', {
    staticClass: "vm-vap-error-msg"
  }, [_vm._v(_vm._s(_vm.errorMsg))]), _vm._v(" "), (_vm.config.status === 1) ? _c('div', {
    staticClass: "vm-vap-error-btn",
    on: {
      "click": _vm.reload
    }
  }, [_c('i'), _vm._v(" "), _c('span', {
    staticClass: "btn-text"
  }, [_vm._v("重新加载")])]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-loader/lib/template-compiler.js?id=data-v-2ecc083c!../~/vue-loader/lib/selector.js?type=template&index=0!./common/vue/error.vue
 ** module id = 73
 ** module chunks = 0 1 2 3
 **/